import { GatewayStatus } from 'constants/gatewayStatuses';

import omit from 'lodash/omit';
import { GatewayPilotModeSchedule } from 'types/embedded/gateway';
import { getId } from 'utils';
import { formatInputInTz, parseDateInput } from 'utils/date';

import { GatewayEditFormValues } from '../types';

const dateToString = (value: Date | string | null) =>
  parseDateInput(value)
    ? formatInputInTz(value, { format: 'yyyy-MM-dd HH:mm:ssxxx', timezone: 'UTC' })
    : null;

const formatGatewayPilotModeSchedule = (
  gatewayPilotModeSchedule: GatewayPilotModeSchedule,
  id: string,
): GatewayPilotModeSchedule | null => {
  const isInitialGatewayPilotModeSchedule = !Object.values(gatewayPilotModeSchedule).some(
    (value) => value,
  );

  if (isInitialGatewayPilotModeSchedule) {
    return null;
  }

  const { periodStart, periodEnd, timeStart, timeEnd } = gatewayPilotModeSchedule;

  return {
    id: gatewayPilotModeSchedule.id,
    gateway: id,
    schedule: gatewayPilotModeSchedule.schedule,
    periodStart: dateToString(periodStart),
    periodEnd: dateToString(periodEnd),
    timeStart: dateToString(timeStart),
    timeEnd: dateToString(timeEnd),
  };
};

export const prepareGatewayEditSubmitValues = ({
  id,
  status,
  deactivationReason,
  attemptIntervalConfig,
  gatewayPilotModeSchedule,
  ...values
}: GatewayEditFormValues) => ({
  ...omit(values, 'method'),
  id: parseInt(getId(id), 10),
  status,
  deactivationReason: getId(status) === GatewayStatus.Disabled ? deactivationReason : null,
  attemptIntervalConfig: attemptIntervalConfig?.split(', ').map(Number),
  gatewayPilotModeSchedule: gatewayPilotModeSchedule
    ? formatGatewayPilotModeSchedule(gatewayPilotModeSchedule, id)
    : null,
});
